// A resposta HTTP de gravação pode ser um objeto, um envelope ou apenas 2xx
// sem corpo. Para recarregar os modelos, a lista GET é a fonte da verdade.
export const templateHasId = (id) =>
  id !== null && id !== undefined && String(id).trim() !== "";

export const templateFromSaveResponse = (response) => {
  const body = response?.data;
  if (!body || typeof body !== "object" || Array.isArray(body)) return null;
  for (const candidate of [body.template, body.data, body]) {
    if (candidate && typeof candidate === "object" && !Array.isArray(candidate) &&
        templateHasId(candidate.id)) {
      return candidate;
    }
  }
  return null;
};

export const findSavedTemplateInList = ({ templates, id, draft, previousIds = [] }) => {
  if (!Array.isArray(templates)) return null;
  if (templateHasId(id)) {
    return templates.find((template) => String(template?.id) === String(id)) || null;
  }
  // Sem id no POST: só podemos selecionar um modelo NOVO que tenha os mesmos
  // campos identificadores. Não confundir com outro modelo de nome parecido.
  const previous = new Set(previousIds.map(String));
  const newMatches = templates.filter((template) =>
    templateHasId(template?.id) &&
    !previous.has(String(template.id)) &&
    String(template.name || "") === String(draft?.name || "") &&
    String(template.title || "") === String(draft?.title || ""),
  );
  if (newMatches.length === 1) return newMatches[0];
  return null;
};
